import Modal from "./Modal";

import SurveyCopy from "../ui/SurveyCopy";

const SurveyCopyModal = ({ open, onClose, surveyId, onSave }) => {
  return (
    <Modal
      title="copySurvey"
      open={open}
      onClose={onClose}
      width="100%"
      height="100%"
    >
      <SurveyCopy
        surveyId={surveyId}
        onSave={onSave}
      />
    </Modal>
  );
};

export default SurveyCopyModal;
